import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Card, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";

// Store
import { pathTitles, useStore } from "../../Store/Store";

export const Programs = (props) => {
  const program = props.program;
  const getLink = useStore((state) => state.getLink);
  const [expectationsOpen, setExpectationsOpen] = useState(false);
  // web browser
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let mobile = false;
  let consultPath = getLink(pathTitles.CONTACTUS);
  if (/android/i.test(userAgent) || /iPad|iPhone|iPod/i.test(userAgent)) {
    consultPath = "sms://+13179546952";
    mobile = true;
  }
  return (
    <Card className="program_card h-100" key={program.programName}>
      {program.image && (
        <div
          className={`${program.image} program_card_image`}
          role="img"
          aria-label={`${program.programName} — Todo's Translator dog training program`}
        ></div>
      )}
      <Card.Body className="program_card_body">
        <Card.Title className="program_card_title">
          {program.programName}
        </Card.Title>
        <Card.Text className="program_card_description">
          {program.definition}
        </Card.Text>
        <div className="program_card_price">{program.cost}</div>
        <div className="program_card_section">
          <h6 className="program_card_section_title">What&apos;s Included</h6>
          <ul className="program_card_list">
            {program.included.map((p, i) => (
              <li key={`${p[1]}_${i}`}>{p}</li>
            ))}
          </ul>
        </div>
        {program.expectations && program.expectations.length > 0 && (
          <div className="program_card_section">
            <button
              type="button"
              className="program_card_expectations_toggle"
              onClick={() => setExpectationsOpen((o) => !o)}
              aria-expanded={expectationsOpen}
            >
              <span className="program_card_expectations_arrow">
                {expectationsOpen ? "▾" : "▸"}
              </span>
              What to expect
            </button>
            <Collapse in={expectationsOpen}>
              <div>
                <ul className="program_card_list program_card_expectations">
                  {program.expectations.map((e, i) => (
                    <li key={`${e[1]}_${i}`}>{e}</li>
                  ))}
                </ul>
              </div>
            </Collapse>
          </div>
        )}
        <div className="program_card_cta">
          <Button className="program_card_button" as={Link} to={consultPath}>
            {mobile ? "Reach out Now" : "Book Now"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

Programs.propTypes = {
  program: PropTypes.object,
};
